import { postJson, remoteErrorMessage } from './remoteError';

/**
 * Asks the server's `checkNutritionFacts` for the foods of a recipe's ingredient lines.
 *
 * `postJson` turns a failed status into an error carrying the server's message, or `messages.serverError`
 * when the body is not JSON (a rejected token comes back as plain text, the functions gateway answers
 * 5xx with HTML). A 200 carrying `error` and an answer with no foods list are errors too, so the editor
 * shows its toast instead of an empty nutrition table (S2-8457).
 *
 * @param {Function} remote `firebase.remote`.
 * @param {string} ingredients The ingredient lines, one per line.
 * @param {{ serverError: string, noFacts: string }} messages The messages for a failure that carries none.
 * @returns {Promise<Array<Object>>} One food per ingredient line, in the Nutritionix `natural/nutrients` shape.
 */
export const checkNutritionFacts = async (remote, ingredients, messages) => {
  const body = await postJson(remote, 'checkNutritionFacts', { ingredients }, messages.serverError);

  if (body?.error) {
    throw new Error(remoteErrorMessage(body.error, messages.noFacts));
  }

  const foods = body?.checkedFacts?.foods;
  if (!Array.isArray(foods)) {
    throw new Error(messages.noFacts);
  }

  return foods;
};
